export default "__VITE_ASSET__Cr46Br8f__"